import {isNumber, isString} from './type-check-kit'

export type Bookmark = string
export const ZERO_BOOKMARK: Bookmark = '0-0'

export type BookmarkProvider = () => Bookmark


export const defaultBookmarkProvider = () => '*'
export const setBookmarkProvider =
    (bookmarkProvider?: BookmarkProvider) => currentBookmarkProvider = bookmarkProvider ?? defaultBookmarkProvider

let currentBookmarkProvider: BookmarkProvider = defaultBookmarkProvider

export const useBookmarkProvider = () => currentBookmarkProvider

export const bookmarkAt = (moment: number, index = 0) => `${moment}-${index}`

export const sortBookmarks = (bookmarks: Bookmark[]) =>
    bookmarks
        .filter((b): b is Bookmark => !!b)
        .map(splitBookmark)
        .sort(compareRankedBookmarks)
        .map(r => r.bookmark)

export const maxBookmark = (bookmarks: Bookmark[]) =>
    bookmarks
        .filter((b): b is Bookmark => !!b)
        .map(splitBookmark)
        .reduce(maxRankedBookmark).bookmark


// -------------------
type RankedBookmark = { bookmark: string, timestamp: number, index: number }

export function compareBookmarks(a: Bookmark, b: Bookmark) {
    return compareRankedBookmarks(splitBookmark(a), splitBookmark(b))
}


export const getTimelineBookmarkProvider = (startDate = Date.now()) => {

    const now = () => {
        const actualNow = Date.now()
        const offset = actualNow - startDate
        return actualNow - offset
    }

    let lastBookmark = {
        timestamp: now(),
        index: 0
    }
    return () => {
        const nowNow = now()
        if (lastBookmark.timestamp < nowNow) {
            lastBookmark = {
                timestamp: nowNow,
                index: 0
            }
        } else {
            lastBookmark = {
                timestamp: lastBookmark.timestamp+1,
                index: lastBookmark.index + 1
            }
        }

        // console.log(`${lastBookmark.timestamp}-${lastBookmark.index}`)

        return `${lastBookmark.timestamp}-${lastBookmark.index}`
    }
}


















export const splitBookmark = (bookmark: Bookmark): RankedBookmark => {
    const [timestamp, index] = bookmark.split('-').map(n => +n)
    return {bookmark, timestamp, index}
}


const maxRankedBookmark = (a: RankedBookmark, b: RankedBookmark) => {
    if (!a) return b
    if (!b) return a
    if (a.timestamp == b.timestamp) return a.index > b.index ? a : b
    return a.timestamp > b.timestamp ? a : b
}

const compareRankedBookmarks = (a: RankedBookmark, b: RankedBookmark) =>
    compareNumbers(a.timestamp, b.timestamp)
    || compareNumbers(a.index, b.index)


const compareNumbers = (a: number, b: number) =>
    Math.sign(a - b)


export type BookmarkOrTimestamp = Bookmark | number


export function resolveBookmark(bookmarkOrTime: BookmarkOrTimestamp, defaultBookmark: Bookmark) {
    return isNumber(bookmarkOrTime) ? bookmarkAt(bookmarkOrTime) : isString(bookmarkOrTime) ? bookmarkOrTime : defaultBookmark
}
